import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const addVendor = createAsyncThunk('addVendor', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'vendor',
            data: data?.values,
            headers: { "Content-Type": "multipart/form-data", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})
